var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5L8 3V4.5H4V5.5H8V7L10 5ZM9 8C8.37035 8.83953 7.49252 9.45967 6.49084 9.77257C5.48916 10.0855 4.41442 10.0753 3.41886 9.74342C2.4233 9.41156 1.55739 8.77488 0.943789 7.92355C0.330187 7.07222 0 6.04941 0 5C0 3.95059 0.330187 2.92778 0.943789 2.07645C1.55739 1.22512 2.4233 0.588437 3.41886 0.256584C4.41442 -0.0752698 5.48916 -0.0854684 6.49084 0.227432C7.49252 0.540333 8.37035 1.16047 9 2H7.635C7.05766 1.49083 6.34566 1.15907 5.58444 1.04453C4.82322 0.929987 4.04511 1.03753 3.3435 1.35425C2.64188 1.67097 2.04656 2.18341 1.62897 2.83009C1.21137 3.47677 0.989249 4.23021 0.989249 5C0.989249 5.76979 1.21137 6.52323 1.62897 7.16991C2.04656 7.81659 2.64188 8.32903 3.3435 8.64575C4.04511 8.96247 4.82322 9.07001 5.58444 8.95547C6.34566 8.84093 7.05766 8.50917 7.635 8H9Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/leftIcon.dc269b1d63ff70aaa43fffd83e58c783.svg";
export { ForwardRef as ReactComponent };